<template>
  <div class="accidentRescueItem">
    <div
      class="item"
      v-for="(item, index) in list"
      :key="index"
      @click="goDetail(item)"
    >
      <div class="title">
        <div class="title-text">{{ item.productCategoryParentName }}/{{ item.productCategoryName }}/{{ item.productName }}</div>
        <div class="status">{{ item.wxDpsStatusAliasName }} <span class="arr">></span></div>
      </div>
      <div class="itemCenter">下单时间: {{ item.createTime }}</div>
      <div class="itemCenter">车牌号码: {{ item.carNo }}</div>
      <div class="location">
        <div class="startPosition">{{ item.contactAddress }}</div>
        <div class="endPosition">{{ item.destination }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
    };
  },
  methods: {
    goDetail(data) {
      this.$router.push({
        path: '/accidentRescue/detail',
        query: {
          orderNo: data.orderNo
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.accidentRescueItem{
  .item{
    overflow: hidden;

    width: 94vw;
    margin: 0.3rem auto;

    border-radius: 0.2rem;
    background: #fff;
    .title{
      display: flex;
      justify-content: space-between;

      box-sizing: border-box;
      padding: 0.3rem;

      color: #383838;
      border-bottom: 1px solid #E6E6E6;

      font-size: 0.32rem;
      font-weight: 900;
      .title-text{
        overflow: hidden;

        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .status{
        flex: 1.2rem 0 0;

        color: #3399FF;

        font-size: 0.30rem;
        font-weight: 400;
        .arr{
          color:#787878;
        }
      }
    }
    .itemCenter{
      box-sizing: border-box;
      margin-top: 0.3rem;
      padding: 0 0.3rem;

      color: #383838;

      font-size: 0.30rem;
    }
    .location{
      box-sizing: border-box;
      width: 88vw;
      margin: 0.3rem auto;
      padding: 0.3rem;

      color: #646464;
      border-radius: 0.1rem;
      background: #EDF5F5;

      font-size: 0.28rem;
      .startPosition,.endPosition{
        position: relative;

        padding-left: 0.4rem;
        &::after{
          position: absolute;
          top: 0.02rem;
          left: 0;

          width: 0.2rem;
          height: 0.2rem;

          content: '';

          border-radius: 50%;
        }
      }
      .startPosition::after{
        background: #5EC360;
      }
      .endPosition{
        margin-top: 0.3rem;
      }
      .endPosition::after{
        background: #FF8A59;
      }
    }
  }
}
</style>
